import { z } from "zod";
import { isValidPhone, PHONE_ERROR } from "@/lib/phone";

export const updateLanguageSchema = z.object({
	language: z.enum(["bs", "en"]),
});

/**
 * `currentPhone` je broj koji je već spremljen na profilu. Ponovno spremanje
 * istog (netaknutog) broja prolazi i kad ne bi prošao provjeru formata, da
 * stari podaci ne blokiraju izmjenu imena.
 */
export function makeUpdateProfileSchema(currentPhone?: string | null) {
	return z.object({
		firstName: z.string().trim().min(1).max(100),
		lastName: z.string().trim().min(1).max(100),
		// Prazno polje briše broj (null); upisan broj mora ličiti na telefon.
		phone: z
			.string()
			.trim()
			.max(40)
			.nullish()
			.transform((v) => (v?.length ? v : null))
			.refine((v) => v === null || v === (currentPhone ?? "").trim() || isValidPhone(v), {
				message: PHONE_ERROR,
			}),
	});
}

export const updateProfileSchema = makeUpdateProfileSchema();

export type UpdateProfileInput = z.infer<typeof updateProfileSchema>;
